/*
 DOCTOR DISCUSSION GUIDE FORM LOGIC
 */

ddg = {

	init: function(){
		ddg.cE();
	},

	cE: function cacheElements() {

		ddg.form = $('form#assessment-form');
		ddg.submitButton = $('#assessment-submit');

		ddg.hiddenShowAllQuestions = $('#show_all_questions');
		ddg.hiddenIntroSection = $('#intro_section');

		ddg.showAllQuestions = false;
		ddg.introSectionNegative = false;

		ddg.inputs = $('input');
		ddg.inputQ1 = $('input[name="q1"]');
		ddg.inputQ2 = $('input[name="q2"]');
		ddg.inputQ3 = $('input[name="q3"]');
		ddg.inputQ4A = $('input[name="q4_a"]');
        ddg.inputQ4B = $('input[name="q4_b"]');
        ddg.inputQ4C = $('input[name="q4_c"]');
		ddg.inputQ5 = $('input[name="q5"]');
		ddg.inputQ6 = $('input[name="q6"]');

		ddg.allAreBlank = false;
		ddg.allAreNegative = false;

		ddg.el();
	},
	el: function eventListeners() {

		ddg.submitButton.on('click', function(e){
			e.preventDefault();
			ddg.checkIfAllBlank();
			if (ddg.allAreBlank) {
				$(ddg.hiddenShowAllQuestions).val('true');
				$(ddg.hiddenIntroSection).val('negative');
			} else {
				ddg.checkIfAllAreNegative();
			}
			$(ddg.form).submit();
		});

	},
	checkIfAllBlank: function checkIfBlank(){
	 $.each(ddg.inputs, function(){
	 	if ($(this).is(':checked')){
		  ddg.allAreBlank = false;
	 		return false;
	  } else {
		  ddg.allAreBlank = true;
	 		return true;
	  }
	 });
	},
	checkIfAllAreNegative: function checkIfAllAreNegative(){
		var q2IsBlank = false;
		var q4IsBlank = false;
		var numberOfNegative = 0;
		if ($(ddg.inputQ2).is(':checked') && $('input[name="q2"]:checked').val() !== 'none'){
			q2IsBlank = false;
		} else {
			q2IsBlank = true;
		}
		if ($(ddg.inputQ4A).is(':checked') || $(ddg.inputQ4B).is(':checked') || $(ddg.inputQ4C).is(':checked')){
			q4IsBlank = false;
		} else {
			q4IsBlank = true;
		}

		if (($(ddg.inputQ1).is(':checked') && $('input[name="q1"]:checked').val() === 'no') || !$(ddg.inputQ1).is(':checked')){
			numberOfNegative++;
		}
		if (($(ddg.inputQ3).is(':checked') && $('input[name="q3"]:checked').val() === 'no') || !$(ddg.inputQ3).is(':checked')){
			numberOfNegative++;
		}
		if (($(ddg.inputQ5).is(':checked') && $('input[name="q5"]:checked').val() === 'no') || !$(ddg.inputQ5).is(':checked')){
			numberOfNegative++;
		}
		if (($(ddg.inputQ6).is(':checked') && $('input[name="q6"]:checked').val() === 'no') || !$(ddg.inputQ6).is(':checked')){
			numberOfNegative++;
		}

		if ((numberOfNegative === 4) && q2IsBlank && q4IsBlank) {
			ddg.allAreNegative = true;
			$(ddg.hiddenShowAllQuestions).val('true');
			$(ddg.hiddenIntroSection).val('negative');
		} else {
			ddg.allAreNegative = false;
			$(ddg.hiddenIntroSection).val('positive');
		}
	}
};
